import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  Users, Plus, Edit, Star, Award, Target, Handshake, UserPlus,
  Calendar, MessageSquare, Camera, Crown, Loader2, Mail, Send,
  ArrowUpRight, Trash2, Lightbulb, Gift, FileText, Video, Megaphone, ExternalLink
} from "lucide-react";

export function CommunityDialogs({
  user,
  // Post Opportunity
  showPostOpportunity, setShowPostOpportunity,
  newOpportunity, setNewOpportunity,
  handlePostOpportunity,
  // Edit Profile
  showEditProfile, setShowEditProfile,
  EditProfileForm, fetchInitialData,
  // Introduction
  showIntroductionDialog, setShowIntroductionDialog,
  introductionText, setIntroductionText,
  handlePostIntroduction,
  // Collaboration Goal
  showCollaborationDialog, setShowCollaborationDialog,
  collaborationGoal, setCollaborationGoal,
  handleSetCollaborationGoal,
  // Photo Upload
  showPhotoUpload, setShowPhotoUpload,
  handlePhotoUpload,
  // Upgrade
  showUpgradeDialog, setShowUpgradeDialog,
  membershipStatus, handleUpgrade,
  // Create Bulletin
  showCreateBulletin, setShowCreateBulletin,
  newBulletin, setNewBulletin,
  handleCreateBulletin,
  // Create Event
  showCreateEvent, setShowCreateEvent,
  newEvent, setNewEvent,
  handleCreateEvent,
  // Discussion Post
  showPostDiscussion, setShowPostDiscussion,
  newDiscussionPost, setNewDiscussionPost,
  handleCreateDiscussionPost,
  // Comments
  showComments, setShowComments,
  selectedPost, postComments,
  newComment, setNewComment,
  handleAddComment, openProfileCard,
  // New Message
  showNewMessage, setShowNewMessage,
  membersDirectory, handleStartConversation,
  // Add/Edit Resource
  showAddResource, setShowAddResource,
  editingResource, setEditingResource,
  newResource, setNewResource,
  resourceCategories,
  handleAddResource, handleUpdateResource,
  // Request Recommendation
  showRequestRecommendation, setShowRequestRecommendation,
  newRecommendation, setNewRecommendation,
  handleSubmitRecommendation, myRecommendations,
  // Pod Details
  showPodDetails, setShowPodDetails,
  selectedPod, setSelectedPod,
  podMembers, setShowAddPodContent,
  setShowEditPod, handleDeletePod,
  fetchWorkshopsAndPodcasts,
  handleRemovePodContent,
  // Create Pod
  showCreatePod, setShowCreatePod,
  newPod, setNewPod, handleCreatePod,
  // Edit Pod
  showEditPod, handleUpdatePod,
  // Add Pod Content
  showAddPodContent,
  newPodContent, setNewPodContent,
  handleAddPodContent,
  // Profile Card
  profileCardUserId, setProfileCardUserId,
  profileCardData, setProfileCardData,
  profileCardLoading, handleConnect
}) {
  return (
    <>
      {/* Post Opportunity Dialog */}
      <Dialog open={showPostOpportunity} onOpenChange={setShowPostOpportunity}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Plus className="w-5 h-5 text-[#39FF14]" />
              Post an Opportunity
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Share an opportunity with the community
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Opportunity Type</Label>
              <Select
                value={newOpportunity.opportunity_type}
                onValueChange={(v) => setNewOpportunity({...newOpportunity, opportunity_type: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="partnership">Partnership & Collaboration</SelectItem>
                  <SelectItem value="referral">Referral Exchange</SelectItem>
                  <SelectItem value="hiring">Hiring & Talent</SelectItem>
                  <SelectItem value="funding">Funding & Investment</SelectItem>
                  <SelectItem value="government">Government Contract</SelectItem>
                  <SelectItem value="marketing">Marketing & Exposure</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-neutral-300">Title</Label>
              <Input
                value={newOpportunity.title}
                onChange={(e) => setNewOpportunity({...newOpportunity, title: e.target.value})}
                placeholder="e.g., Looking for Marketing Partner"
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Description</Label>
              <Textarea
                value={newOpportunity.description}
                onChange={(e) => setNewOpportunity({...newOpportunity, description: e.target.value})}
                placeholder="Describe the opportunity..."
                className="bg-neutral-900 border-neutral-700 min-h-[100px]"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Who I&apos;m Looking For</Label>
              <Input
                value={newOpportunity.looking_for}
                onChange={(e) => setNewOpportunity({...newOpportunity, looking_for: e.target.value})}
                placeholder="e.g., Digital marketing agency with B2B experience"
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-neutral-300">Timeline</Label>
                <Input
                  value={newOpportunity.timeline}
                  onChange={(e) => setNewOpportunity({...newOpportunity, timeline: e.target.value})}
                  placeholder="e.g., Q1 2026"
                  className="bg-neutral-900 border-neutral-700"
                />
              </div>
              <div>
                <Label className="text-neutral-300">Contact Method</Label>
                <Input
                  value={newOpportunity.contact_method}
                  onChange={(e) => setNewOpportunity({...newOpportunity, contact_method: e.target.value})}
                  placeholder="e.g., DM or email"
                  className="bg-neutral-900 border-neutral-700"
                />
              </div>
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowPostOpportunity(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handlePostOpportunity}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newOpportunity.title || !newOpportunity.description || !newOpportunity.looking_for}
            >
              Post Opportunity
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Profile Dialog */}
      <Dialog open={showEditProfile} onOpenChange={setShowEditProfile}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Edit className="w-5 h-5 text-[#39FF14]" />
              Complete Your Profile
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Share your business details to connect with the right partners
            </DialogDescription>
          </DialogHeader>
          <EditProfileForm onComplete={() => { setShowEditProfile(false); fetchInitialData(); }} />
        </DialogContent>
      </Dialog>

      {/* Introduction Dialog */}
      <Dialog open={showIntroductionDialog} onOpenChange={setShowIntroductionDialog}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-[#39FF14]" />
              Post Your Introduction
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Introduce yourself to the community
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <Textarea
              value={introductionText}
              onChange={(e) => setIntroductionText(e.target.value)}
              placeholder="Hi everyone! I'm [Your Name] and I run [Your Business]. I specialize in [What You Do] and I'm excited to connect with fellow entrepreneurs who..."
              className="bg-neutral-900 border-neutral-700 min-h-[150px]"
              data-testid="introduction-textarea"
            />
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowIntroductionDialog(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handlePostIntroduction}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!introductionText.trim()}
              data-testid="post-introduction-btn"
            >
              Post Introduction
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Collaboration Goal Dialog */}
      <Dialog open={showCollaborationDialog} onOpenChange={setShowCollaborationDialog}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Star className="w-5 h-5 text-[#39FF14]" />
              Set Your Collaboration Goal
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              What are you looking to achieve through partnerships?
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <Select value={collaborationGoal} onValueChange={setCollaborationGoal}>
              <SelectTrigger className="bg-neutral-900 border-neutral-700">
                <SelectValue placeholder="Select your main collaboration goal" />
              </SelectTrigger>
              <SelectContent className="bg-neutral-800 border-neutral-700">
                <SelectItem value="find_partners">Find Strategic Partners</SelectItem>
                <SelectItem value="grow_referrals">Grow Referral Network</SelectItem>
                <SelectItem value="secure_funding">Secure Funding/Investment</SelectItem>
                <SelectItem value="expand_clients">Expand Client Base</SelectItem>
                <SelectItem value="find_suppliers">Find Quality Suppliers</SelectItem>
                <SelectItem value="build_team">Build/Hire Team Members</SelectItem>
                <SelectItem value="learn_grow">Learn & Grow from Peers</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowCollaborationDialog(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleSetCollaborationGoal}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!collaborationGoal}
              data-testid="set-collaboration-goal-btn"
            >
              Set Goal
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Photo Upload Dialog */}
      <Dialog open={showPhotoUpload} onOpenChange={setShowPhotoUpload}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Camera className="w-5 h-5 text-[#39FF14]" />
              Upload Profile Photo
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Add a professional photo to your community profile. Required to unlock Premium upgrade.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div className="border-2 border-dashed border-neutral-600 rounded-lg p-8 text-center hover:border-[#39FF14]/50 transition-colors">
              <Camera className="w-12 h-12 text-neutral-500 mx-auto mb-3" />
              <p className="text-sm text-neutral-400 mb-3">JPG, PNG or WebP (max 2MB)</p>
              <label className="cursor-pointer">
                <input
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  className="hidden"
                  onChange={handlePhotoUpload}
                  data-testid="photo-upload-input"
                />
                <span className="inline-block bg-[#39FF14] text-black px-4 py-2 rounded-lg font-semibold text-sm hover:bg-[#32e612] transition-colors">
                  Choose Photo
                </span>
              </label>
            </div>
            <div className="flex items-center gap-2 text-xs text-neutral-500">
              <Award className="w-3 h-3" />
              <span>Earn 5 points for uploading your photo</span>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowPhotoUpload(false)} className="border-neutral-600">
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Upgrade Dialog */}
      <Dialog open={showUpgradeDialog} onOpenChange={setShowUpgradeDialog}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-md">
          <DialogHeader>
            <div className="flex items-center gap-3 mb-2">
              <img
                src="https://customer-assets.emergentagent.com/job_1f6fc830-db93-46be-8373-0fbe94240b47/artifacts/1h0hcmcd_MBC%20logo%20%28400%20x%20400%20px%29.png"
                alt="My Biz Consulting"
                className="w-10 h-10 object-contain"
              />
              <DialogTitle className="flex items-center gap-2">
                <Crown className="w-5 h-5 text-amber-400" />
                Upgrade to Premium
              </DialogTitle>
            </div>
            <DialogDescription className="text-neutral-400">
              Get full access to all My Biz Consulting community features
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-4">
            <div className="bg-gradient-to-r from-amber-900/20 to-neutral-900 p-4 rounded-lg border border-amber-500/20">
              <div className="text-3xl font-bold text-white mb-1">
                $5.99<span className="text-lg font-normal text-neutral-400">/month</span>
              </div>
              <p className="text-sm text-neutral-400">Cancel anytime</p>
            </div>
            <div className="space-y-3">
              <p className="text-sm font-medium text-white">Premium includes:</p>
              {[
                { icon: Mail, text: "Messages - Direct member-to-member messaging" },
                { icon: Handshake, text: "Networking Lounge - Find partnerships & referrals" },
                { icon: Target, text: "Opportunity Marketplace - Post & discover deals" },
                { icon: Target, text: "Mastermind Pods - Join curated business groups" },
                { icon: Gift, text: "Resource Vault - Grants, templates & training" }
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3 text-neutral-300">
                  <item.icon className="w-4 h-4 text-[#39FF14]" />
                  <span className="text-sm">{item.text}</span>
                </div>
              ))}
            </div>
            {membershipStatus && !membershipStatus.has_profile_photo && (
              <div className="p-3 bg-amber-900/20 rounded-lg border border-amber-500/30">
                <p className="text-sm text-amber-300 flex items-center gap-2">
                  <Camera className="w-4 h-4" />
                  Profile photo required before upgrading
                </p>
                <Button
                  size="sm"
                  onClick={() => { setShowUpgradeDialog(false); setShowPhotoUpload(true); }}
                  className="mt-2 bg-amber-500 text-black hover:bg-amber-400 text-xs"
                  data-testid="upload-photo-from-upgrade-btn"
                >
                  Upload Photo Now
                </Button>
              </div>
            )}
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowUpgradeDialog(false)} className="border-neutral-600">
              Maybe Later
            </Button>
            <Button
              onClick={handleUpgrade}
              disabled={membershipStatus && !membershipStatus.can_upgrade}
              className="bg-amber-500 text-black hover:bg-amber-400 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="confirm-upgrade-btn"
            >
              {membershipStatus?.can_upgrade ? "Upgrade Now" : "Photo Required"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Create Bulletin Dialog */}
      <Dialog open={showCreateBulletin} onOpenChange={setShowCreateBulletin}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Megaphone className="w-5 h-5 text-[#39FF14]" />
              Post Community Update
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Share news and announcements with the community
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Title</Label>
              <Input
                value={newBulletin.title}
                onChange={(e) => setNewBulletin({...newBulletin, title: e.target.value})}
                placeholder="Announcement title..."
                className="bg-neutral-900 border-neutral-700"
                data-testid="bulletin-title"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Category</Label>
              <Select
                value={newBulletin.category}
                onValueChange={(v) => setNewBulletin({...newBulletin, category: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="announcement">Announcement</SelectItem>
                  <SelectItem value="update">Platform Update</SelectItem>
                  <SelectItem value="spotlight">Member Spotlight</SelectItem>
                  <SelectItem value="opportunity">Featured Opportunity</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-neutral-300">Content</Label>
              <Textarea
                value={newBulletin.content}
                onChange={(e) => setNewBulletin({...newBulletin, content: e.target.value})}
                placeholder="Write your announcement..."
                className="bg-neutral-900 border-neutral-700 min-h-[150px]"
                data-testid="bulletin-content"
              />
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowCreateBulletin(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleCreateBulletin}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newBulletin.title || !newBulletin.content}
              data-testid="post-bulletin-btn"
            >
              Post Update
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Create Event Dialog */}
      <Dialog open={showCreateEvent} onOpenChange={setShowCreateEvent}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Calendar className="w-5 h-5 text-[#39FF14]" />
              Create Event
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Schedule a community event or workshop
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Event Title *</Label>
              <Input
                value={newEvent.title}
                onChange={(e) => setNewEvent({...newEvent, title: e.target.value})}
                placeholder="e.g., Monthly Networking Mixer"
                className="bg-neutral-900 border-neutral-700"
                data-testid="event-title"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Description</Label>
              <Textarea
                value={newEvent.description}
                onChange={(e) => setNewEvent({...newEvent, description: e.target.value})}
                placeholder="What will happen at this event?"
                className="bg-neutral-900 border-neutral-700 min-h-[80px]"
                data-testid="event-description"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-neutral-300">Date *</Label>
                <Input
                  type="date"
                  value={newEvent.date}
                  onChange={(e) => setNewEvent({...newEvent, date: e.target.value})}
                  className="bg-neutral-900 border-neutral-700"
                  data-testid="event-date"
                />
              </div>
              <div>
                <Label className="text-neutral-300">Time *</Label>
                <Input
                  type="time"
                  value={newEvent.time}
                  onChange={(e) => setNewEvent({...newEvent, time: e.target.value})}
                  className="bg-neutral-900 border-neutral-700"
                  data-testid="event-time"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-neutral-300">Duration (minutes)</Label>
                <Select
                  value={newEvent.duration}
                  onValueChange={(v) => setNewEvent({...newEvent, duration: v})}
                >
                  <SelectTrigger className="bg-neutral-900 border-neutral-700">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-neutral-800 border-neutral-700">
                    <SelectItem value="30">30 minutes</SelectItem>
                    <SelectItem value="60">1 hour</SelectItem>
                    <SelectItem value="90">1.5 hours</SelectItem>
                    <SelectItem value="120">2 hours</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label className="text-neutral-300">Meeting Link</Label>
                <Input
                  value={newEvent.meeting_link}
                  onChange={(e) => setNewEvent({...newEvent, meeting_link: e.target.value})}
                  placeholder="Zoom/Meet link"
                  className="bg-neutral-900 border-neutral-700"
                />
              </div>
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowCreateEvent(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleCreateEvent}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newEvent.title || !newEvent.date || !newEvent.time}
              data-testid="create-event-submit-btn"
            >
              Create Event
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Create Discussion Post Dialog */}
      <Dialog open={showPostDiscussion} onOpenChange={setShowPostDiscussion}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-[#39FF14]" />
              Share with the Community
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Post a question, win, or just say hello
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Category</Label>
              <Select
                value={newDiscussionPost.category}
                onValueChange={(v) => setNewDiscussionPost({...newDiscussionPost, category: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="general">General Discussion</SelectItem>
                  <SelectItem value="question">Question</SelectItem>
                  <SelectItem value="win">Win & Celebration</SelectItem>
                  <SelectItem value="intro">Introduction</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-neutral-300">Your Post</Label>
              <Textarea
                value={newDiscussionPost.content}
                onChange={(e) => setNewDiscussionPost({...newDiscussionPost, content: e.target.value})}
                placeholder="What's on your mind? Share a win, ask a question, or introduce yourself..."
                className="bg-neutral-900 border-neutral-700 min-h-[150px]"
                data-testid="discussion-post-content"
              />
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowPostDiscussion(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleCreateDiscussionPost}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newDiscussionPost.content.trim()}
              data-testid="submit-discussion-post-btn"
            >
              Post
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Comments Dialog */}
      <Dialog open={showComments} onOpenChange={setShowComments}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg max-h-[80vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-[#39FF14]" />
              Comments
            </DialogTitle>
          </DialogHeader>
          {selectedPost && (
            <div className="p-3 bg-neutral-900 rounded-lg mb-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="font-medium text-white cursor-pointer hover:text-[#39FF14] transition-colors" onClick={() => openProfileCard(selectedPost.user_id)}>{selectedPost.author_name}</span>
                <span className="text-xs text-neutral-500">
                  {selectedPost.created_at ? new Date(selectedPost.created_at).toLocaleDateString() : ""}
                </span>
              </div>
              <p className="text-neutral-300 text-sm">{selectedPost.content}</p>
            </div>
          )}
          <div className="flex-1 overflow-y-auto space-y-3 mb-4 max-h-[300px]">
            {postComments.length > 0 ? postComments.map((comment) => (
              <div key={comment.comment_id} className="flex items-start gap-3 p-2">
                <div className="w-8 h-8 bg-[#39FF14]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Users className="w-4 h-4 text-[#39FF14]" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium text-white text-sm cursor-pointer hover:text-[#39FF14] transition-colors" onClick={() => openProfileCard(comment.user_id)}>{comment.author_name}</span>
                    <span className="text-xs text-neutral-500">
                      {comment.created_at ? new Date(comment.created_at).toLocaleDateString() : ""}
                    </span>
                  </div>
                  <p className="text-neutral-300 text-sm">{comment.content}</p>
                </div>
              </div>
            )) : (
              <p className="text-center text-neutral-500 py-4">No comments yet</p>
            )}
          </div>
          <div className="flex gap-2">
            <Input
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              placeholder="Write a comment..."
              className="bg-neutral-900 border-neutral-700 flex-1"
              onKeyDown={(e) => e.key === "Enter" && handleAddComment()}
              data-testid="comment-input"
            />
            <Button
              onClick={handleAddComment}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newComment.trim()}
            >
              Send
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* New Message Dialog */}
      <Dialog open={showNewMessage} onOpenChange={setShowNewMessage}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Mail className="w-5 h-5 text-[#39FF14]" />
              Start a Conversation
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Select a member to message
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-2 max-h-[400px] overflow-y-auto">
            {membersDirectory.filter(m => m.user_id !== user?.user_id).map((member) => (
              <div
                key={member.user_id}
                onClick={() => handleStartConversation(member)}
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-neutral-700/50 cursor-pointer transition-colors"
              >
                <div className="w-10 h-10 bg-[#39FF14]/10 rounded-full flex items-center justify-center">
                  {member.picture ? (
                    <img src={member.picture} alt="" className="w-10 h-10 rounded-full" />
                  ) : (
                    <Users className="w-5 h-5 text-[#39FF14]" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-white truncate">{member.name || "Member"}</p>
                  <p className="text-sm text-neutral-400 truncate">{member.business_description?.slice(0, 50) || "Community Member"}</p>
                </div>
                {member.membership_tier === "premium" && (
                  <Crown className="w-4 h-4 text-amber-400" />
                )}
                <ArrowUpRight className="w-4 h-4 text-neutral-500" />
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>

      {/* Add/Edit Resource Dialog */}
      <Dialog open={showAddResource} onOpenChange={(open) => {
        setShowAddResource(open);
        if (!open) { setEditingResource(null); setNewResource({ title: "", description: "", category: "templates", resource_url: "", resource_type: "link", is_featured: false }); }
      }}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Gift className="w-5 h-5 text-[#39FF14]" />
              {editingResource ? "Edit Resource" : "Add Resource to Vault"}
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Share useful resources with the community
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Title *</Label>
              <Input
                value={newResource.title}
                onChange={(e) => setNewResource({...newResource, title: e.target.value})}
                placeholder="Resource title..."
                className="bg-neutral-900 border-neutral-700"
                data-testid="resource-title"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Description</Label>
              <Textarea
                value={newResource.description}
                onChange={(e) => setNewResource({...newResource, description: e.target.value})}
                placeholder="What is this resource about?"
                className="bg-neutral-900 border-neutral-700 min-h-[80px]"
                data-testid="resource-description"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-neutral-300">Category *</Label>
                <Select
                  value={newResource.category}
                  onValueChange={(v) => setNewResource({...newResource, category: v})}
                >
                  <SelectTrigger className="bg-neutral-900 border-neutral-700">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-neutral-800 border-neutral-700">
                    {(resourceCategories || []).map(cat => (
                      <SelectItem key={cat.id} value={cat.id}>{cat.name}</SelectItem>
                    ))}
                    {(!resourceCategories || resourceCategories.length === 0) && (
                      <>
                        <SelectItem value="grants">Grant Opportunities</SelectItem>
                        <SelectItem value="funding">Funding & Capital</SelectItem>
                        <SelectItem value="templates">Business Templates</SelectItem>
                        <SelectItem value="legal">Legal & Compliance</SelectItem>
                        <SelectItem value="marketing">Marketing Tools</SelectItem>
                        <SelectItem value="contracting">Contracting Resources</SelectItem>
                        <SelectItem value="training">Recorded Trainings</SelectItem>
                        <SelectItem value="vendors">Vendor Directory</SelectItem>
                      </>
                    )}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label className="text-neutral-300">Type</Label>
                <Select
                  value={newResource.resource_type}
                  onValueChange={(v) => setNewResource({...newResource, resource_type: v})}
                >
                  <SelectTrigger className="bg-neutral-900 border-neutral-700">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-neutral-800 border-neutral-700">
                    <SelectItem value="link">Link/Website</SelectItem>
                    <SelectItem value="document">Document/PDF</SelectItem>
                    <SelectItem value="video">Video</SelectItem>
                    <SelectItem value="template">Template</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div>
              <Label className="text-neutral-300">Resource URL</Label>
              <Input
                value={newResource.resource_url}
                onChange={(e) => setNewResource({...newResource, resource_url: e.target.value})}
                placeholder="https://..."
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="is_featured"
                checked={newResource.is_featured}
                onChange={(e) => setNewResource({...newResource, is_featured: e.target.checked})}
                className="w-4 h-4 rounded border-neutral-600"
              />
              <Label htmlFor="is_featured" className="text-neutral-300 cursor-pointer">
                Feature this resource (show badge)
              </Label>
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowAddResource(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={editingResource ? handleUpdateResource : handleAddResource}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newResource.title.trim()}
              data-testid="save-resource-btn"
            >
              {editingResource ? "Update Resource" : "Add Resource"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Request Recommendation Dialog */}
      <Dialog open={showRequestRecommendation} onOpenChange={setShowRequestRecommendation}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Lightbulb className="w-5 h-5 text-amber-400" />
              Request Tool Recommendation
            </DialogTitle>
            <DialogDescription className="text-neutral-400">
              Tell us what you need and our consultant will provide personalized recommendations
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Category *</Label>
              <Select
                value={newRecommendation.category}
                onValueChange={(v) => setNewRecommendation({...newRecommendation, category: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue placeholder="Select category" />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="CRM">CRM & Sales</SelectItem>
                  <SelectItem value="Accounting">Accounting & Finance</SelectItem>
                  <SelectItem value="Marketing">Marketing & Social Media</SelectItem>
                  <SelectItem value="Project Management">Project Management</SelectItem>
                  <SelectItem value="E-commerce">E-commerce & Online Sales</SelectItem>
                  <SelectItem value="Communication">Communication & Collaboration</SelectItem>
                  <SelectItem value="Design">Design & Creative</SelectItem>
                  <SelectItem value="Other">Other</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-neutral-300">Budget *</Label>
              <Select
                value={newRecommendation.budget}
                onValueChange={(v) => setNewRecommendation({...newRecommendation, budget: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue placeholder="Select budget range" />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="free">Free tools only</SelectItem>
                  <SelectItem value="low">Under $50/month</SelectItem>
                  <SelectItem value="medium">$50 - $200/month</SelectItem>
                  <SelectItem value="high">$200+/month</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-neutral-300">Current Tools (optional)</Label>
              <Input
                value={newRecommendation.current_tools}
                onChange={(e) => setNewRecommendation({...newRecommendation, current_tools: e.target.value})}
                placeholder="e.g., Excel spreadsheets, manual tracking"
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div>
              <Label className="text-neutral-300">What do you need? *</Label>
              <Textarea
                value={newRecommendation.specific_needs}
                onChange={(e) => setNewRecommendation({...newRecommendation, specific_needs: e.target.value})}
                placeholder="Describe your specific needs, pain points, and what features are most important to you..."
                className="bg-neutral-900 border-neutral-700 min-h-[100px]"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Urgency</Label>
              <Select
                value={newRecommendation.urgency}
                onValueChange={(v) => setNewRecommendation({...newRecommendation, urgency: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="urgent">Urgent - Need ASAP</SelectItem>
                  <SelectItem value="normal">Normal - Within a week</SelectItem>
                  <SelectItem value="low">Low - Just exploring</SelectItem>
                </SelectContent>
              </Select>
            </div>
            {myRecommendations.length > 0 && (
              <div className="border-t border-neutral-700 pt-4 mt-4">
                <h4 className="text-sm font-medium text-white mb-3">Your Previous Requests</h4>
                <div className="space-y-2 max-h-[150px] overflow-y-auto">
                  {myRecommendations.slice(0, 5).map((req) => (
                    <div key={req.recommendation_id} className="p-3 bg-neutral-900 rounded-lg">
                      <div className="flex items-center justify-between mb-1">
                        <span className="font-medium text-white text-sm">{req.category}</span>
                        <Badge className={req.status === "responded" ? "bg-green-500/20 text-green-400" : "bg-amber-500/20 text-amber-400"}>
                          {req.status}
                        </Badge>
                      </div>
                      <p className="text-xs text-neutral-400 line-clamp-1">{req.specific_needs}</p>
                      {req.consultant_response && (
                        <div className="mt-2 p-2 bg-[#39FF14]/10 rounded border-l-2 border-[#39FF14]">
                          <p className="text-xs text-neutral-300 line-clamp-2">{req.consultant_response}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowRequestRecommendation(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleSubmitRecommendation}
              className="bg-amber-500 text-black hover:bg-amber-400"
              disabled={!newRecommendation.category || !newRecommendation.budget || !newRecommendation.specific_needs}
              data-testid="submit-recommendation-btn"
            >
              <Send className="w-4 h-4 mr-2" />
              Submit Request
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Pod Details Dialog */}
      <Dialog open={showPodDetails} onOpenChange={setShowPodDetails}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[#39FF14]/10 rounded-lg flex items-center justify-center">
                <Target className="w-5 h-5 text-[#39FF14]" />
              </div>
              <div>
                {selectedPod?.name}
                <p className="text-sm font-normal text-neutral-400">{selectedPod?.member_count || 0} members</p>
              </div>
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <p className="text-sm text-neutral-300">{selectedPod?.description}</p>
            {user?.role === "consultant" && (
              <div className="flex gap-2 p-3 bg-amber-500/10 rounded-lg border border-amber-500/20">
                <Button
                  size="sm"
                  onClick={() => { setShowAddPodContent(true); fetchWorkshopsAndPodcasts(); }}
                  className="bg-amber-500 text-black hover:bg-amber-400"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Add Content
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => setShowEditPod(true)}
                  className="border-amber-500/50 text-amber-400 hover:bg-amber-500/20"
                >
                  <Edit className="w-4 h-4 mr-2" />
                  Edit Pod
                </Button>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => handleDeletePod(selectedPod?.pod_id)}
                  className="text-red-400 hover:bg-red-500/20"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            )}
            <div>
              <h4 className="font-semibold text-white mb-3 flex items-center gap-2">
                <FileText className="w-4 h-4 text-[#39FF14]" />
                Shared Content
              </h4>
              {selectedPod?.content && selectedPod.content.length > 0 ? (
                <div className="space-y-3">
                  {selectedPod.content.map((item) => (
                    <div
                      key={item.content_id}
                      className={`p-4 rounded-lg border ${item.is_pinned ? "bg-[#39FF14]/10 border-[#39FF14]/30" : "bg-neutral-900 border-neutral-700"}`}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3">
                          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                            item.content_type === "workshop" ? "bg-blue-500/20" :
                            item.content_type === "podcast" ? "bg-purple-500/20" :
                            item.content_type === "resource" ? "bg-amber-500/20" :
                            "bg-[#39FF14]/20"
                          }`}>
                            {item.content_type === "workshop" && <Calendar className="w-4 h-4 text-blue-400" />}
                            {item.content_type === "podcast" && <Video className="w-4 h-4 text-purple-400" />}
                            {item.content_type === "resource" && <FileText className="w-4 h-4 text-amber-400" />}
                            {item.content_type === "announcement" && <Megaphone className="w-4 h-4 text-[#39FF14]" />}
                          </div>
                          <div>
                            <div className="flex items-center gap-2">
                              <p className="font-medium text-white">{item.title}</p>
                              {item.is_pinned && <Badge className="bg-[#39FF14] text-black text-xs">Pinned</Badge>}
                            </div>
                            {item.description && (
                              <p className="text-sm text-neutral-400 mt-1">{item.description}</p>
                            )}
                            <p className="text-xs text-neutral-500 mt-2">
                              Added by {item.added_by_name} &bull; {new Date(item.added_at).toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          {item.url && (
                            <Button
                              size="sm"
                              variant="ghost"
                              className="text-[#39FF14] hover:bg-[#39FF14]/20"
                              onClick={() => window.open(item.url, "_blank")}
                            >
                              <ExternalLink className="w-4 h-4" />
                            </Button>
                          )}
                          {user?.role === "consultant" && (
                            <Button
                              size="sm"
                              variant="ghost"
                              className="text-red-400 hover:bg-red-500/20"
                              onClick={() => handleRemovePodContent(item.content_id)}
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8 text-neutral-500">
                  <FileText className="w-10 h-10 mx-auto mb-2 opacity-30" />
                  <p>No content shared yet</p>
                  {user?.role === "consultant" && (
                    <Button
                      className="mt-3 bg-[#39FF14] text-black hover:bg-[#32e612]"
                      onClick={() => { setShowAddPodContent(true); fetchWorkshopsAndPodcasts(); }}
                    >
                      Add First Content
                    </Button>
                  )}
                </div>
              )}
            </div>
            <div>
              <h4 className="font-semibold text-white mb-3 flex items-center gap-2">
                <Users className="w-4 h-4 text-[#39FF14]" />
                Members ({podMembers.length})
              </h4>
              {podMembers.length > 0 ? (
                <div className="grid grid-cols-2 gap-2 max-h-[200px] overflow-y-auto">
                  {podMembers.map((member) => (
                    <div key={member.user_id} className="flex items-center gap-2 p-2 bg-neutral-900 rounded-lg cursor-pointer hover:bg-neutral-800 transition-colors" onClick={() => openProfileCard(member.user_id)}>
                      <div className="w-8 h-8 bg-[#39FF14]/10 rounded-full flex items-center justify-center">
                        <Users className="w-4 h-4 text-[#39FF14]" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-white truncate hover:text-[#39FF14]">{member.name || "Member"}</p>
                        <p className="text-xs text-neutral-400 truncate">{member.business_name || ""}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-neutral-500">No members yet</p>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Create Pod Dialog */}
      <Dialog open={showCreatePod} onOpenChange={setShowCreatePod}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Target className="w-5 h-5 text-[#39FF14]" />
              Create New Pod
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Pod Name *</Label>
              <Input
                value={newPod.name}
                onChange={(e) => setNewPod({...newPod, name: e.target.value})}
                placeholder="e.g., E-commerce Entrepreneurs"
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Description *</Label>
              <Textarea
                value={newPod.description}
                onChange={(e) => setNewPod({...newPod, description: e.target.value})}
                placeholder="What is this pod about? Who should join?"
                className="bg-neutral-900 border-neutral-700 min-h-[80px]"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Pod Type</Label>
              <Select
                value={newPod.pod_type}
                onValueChange={(v) => setNewPod({...newPod, pod_type: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="startup">Startup Founders</SelectItem>
                  <SelectItem value="scaling">Scaling CEOs</SelectItem>
                  <SelectItem value="women">Women in Business</SelectItem>
                  <SelectItem value="service">Service Providers</SelectItem>
                  <SelectItem value="retail">Brick & Mortar</SelectItem>
                  <SelectItem value="government">Government Contractors</SelectItem>
                  <SelectItem value="nonprofit">Nonprofits</SelectItem>
                  <SelectItem value="custom">Custom</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowCreatePod(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleCreatePod}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newPod.name.trim() || !newPod.description.trim()}
            >
              Create Pod
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Pod Dialog */}
      <Dialog open={showEditPod} onOpenChange={setShowEditPod}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Edit className="w-5 h-5 text-[#39FF14]" />
              Edit Pod
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Pod Name</Label>
              <Input
                value={selectedPod?.name || ""}
                onChange={(e) => setSelectedPod({...selectedPod, name: e.target.value})}
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Description</Label>
              <Textarea
                value={selectedPod?.description || ""}
                onChange={(e) => setSelectedPod({...selectedPod, description: e.target.value})}
                className="bg-neutral-900 border-neutral-700 min-h-[80px]"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Pod Type</Label>
              <Select
                value={selectedPod?.pod_type || "custom"}
                onValueChange={(v) => setSelectedPod({...selectedPod, pod_type: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="startup">Startup Founders</SelectItem>
                  <SelectItem value="scaling">Scaling CEOs</SelectItem>
                  <SelectItem value="women">Women in Business</SelectItem>
                  <SelectItem value="service">Service Providers</SelectItem>
                  <SelectItem value="retail">Brick & Mortar</SelectItem>
                  <SelectItem value="government">Government Contractors</SelectItem>
                  <SelectItem value="nonprofit">Nonprofits</SelectItem>
                  <SelectItem value="custom">Custom</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowEditPod(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleUpdatePod}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
            >
              Save Changes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Add Pod Content Dialog */}
      <Dialog open={showAddPodContent} onOpenChange={setShowAddPodContent}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Plus className="w-5 h-5 text-[#39FF14]" />
              Add Content to {selectedPod?.name}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-neutral-300">Content Type</Label>
              <Select
                value={newPodContent.content_type}
                onValueChange={(v) => setNewPodContent({...newPodContent, content_type: v})}
              >
                <SelectTrigger className="bg-neutral-900 border-neutral-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-neutral-700">
                  <SelectItem value="announcement">Announcement</SelectItem>
                  <SelectItem value="workshop">Workshop Link</SelectItem>
                  <SelectItem value="podcast">Podcast Episode</SelectItem>
                  <SelectItem value="resource">Resource/Link</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-neutral-300">Title *</Label>
              <Input
                value={newPodContent.title}
                onChange={(e) => setNewPodContent({...newPodContent, title: e.target.value})}
                placeholder="e.g., Upcoming Workshop: Sales Mastery"
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div>
              <Label className="text-neutral-300">Description</Label>
              <Textarea
                value={newPodContent.description}
                onChange={(e) => setNewPodContent({...newPodContent, description: e.target.value})}
                placeholder="Brief description of this content..."
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
            <div>
              <Label className="text-neutral-300">URL/Link</Label>
              <Input
                value={newPodContent.url}
                onChange={(e) => setNewPodContent({...newPodContent, url: e.target.value})}
                placeholder="https://..."
                className="bg-neutral-900 border-neutral-700"
              />
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => setShowAddPodContent(false)} className="border-neutral-600">
              Cancel
            </Button>
            <Button
              onClick={handleAddPodContent}
              className="bg-[#39FF14] text-black hover:bg-[#32e612]"
              disabled={!newPodContent.title.trim()}
            >
              Add Content
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Member Profile Card Dialog */}
      <Dialog open={!!profileCardUserId} onOpenChange={(open) => { if (!open) { setProfileCardUserId(null); setProfileCardData(null); } }}>
        <DialogContent className="bg-neutral-800 border-neutral-700 text-white max-w-md" data-testid="member-profile-card">
          {profileCardLoading ? (
            <div className="flex items-center justify-center py-12">
              <DialogHeader className="sr-only"><DialogTitle>Loading Profile</DialogTitle></DialogHeader>
              <Loader2 className="w-8 h-8 animate-spin text-[#39FF14]" />
            </div>
          ) : profileCardData ? (
            <>
              <DialogHeader>
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-[#39FF14]/10 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden">
                    {profileCardData.user?.picture ? (
                      <img src={profileCardData.user.picture} alt="" className="w-16 h-16 rounded-full object-cover" />
                    ) : (
                      <Users className="w-8 h-8 text-[#39FF14]" />
                    )}
                  </div>
                  <div>
                    <DialogTitle className="text-lg">{profileCardData.user?.name || "Member"}</DialogTitle>
                    {profileCardData.user?.created_at && (
                      <p className="text-xs text-neutral-500">Member since {new Date(profileCardData.user.created_at).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
                    )}
                  </div>
                </div>
              </DialogHeader>
              <div className="space-y-4 pt-3">
                {profileCardData.profile?.business_description && (
                  <div>
                    <p className="text-xs text-neutral-500 mb-1 uppercase tracking-wide">About</p>
                    <p className="text-sm text-neutral-300">{profileCardData.profile.business_description}</p>
                  </div>
                )}
                {profileCardData.profile?.services_offered?.length > 0 && (
                  <div>
                    <p className="text-xs text-neutral-500 mb-1 uppercase tracking-wide">Services Offered</p>
                    <div className="flex flex-wrap gap-1">
                      {profileCardData.profile.services_offered.map((s, i) => (
                        <Badge key={i} variant="outline" className="border-[#39FF14]/30 text-[#39FF14] text-xs">{s}</Badge>
                      ))}
                    </div>
                  </div>
                )}
                {profileCardData.profile?.looking_for?.length > 0 && (
                  <div>
                    <p className="text-xs text-neutral-500 mb-1 uppercase tracking-wide">Looking For</p>
                    <div className="flex flex-wrap gap-1">
                      {profileCardData.profile.looking_for.map((l, i) => (
                        <Badge key={i} variant="outline" className="border-amber-500/30 text-amber-400 text-xs capitalize">{l.replace(/_/g, " ")}</Badge>
                      ))}
                    </div>
                  </div>
                )}
                {profileCardData.profile?.collaboration_interests?.length > 0 && (
                  <div>
                    <p className="text-xs text-neutral-500 mb-1 uppercase tracking-wide">Collaboration Interests</p>
                    <div className="flex flex-wrap gap-1">
                      {profileCardData.profile.collaboration_interests.map((c, i) => (
                        <Badge key={i} variant="outline" className="border-purple-500/30 text-purple-400 text-xs capitalize">{c.replace(/_/g, " ")}</Badge>
                      ))}
                    </div>
                  </div>
                )}
                <div className="flex items-center gap-4 text-xs text-neutral-500 pt-2 border-t border-neutral-700">
                  <span className="flex items-center gap-1"><Award className="w-3 h-3 text-[#39FF14]" /> {profileCardData.profile?.total_points || 0} points</span>
                  <span className="flex items-center gap-1"><Handshake className="w-3 h-3" /> {profileCardData.profile?.connections_count || 0} connections</span>
                  <span className="flex items-center gap-1"><Target className="w-3 h-3" /> {profileCardData.profile?.pods_joined?.length || 0} pods</span>
                </div>
                {profileCardData.profile?.booking_link && (
                  <Button
                    variant="outline"
                    size="sm"
                    className="w-full border-neutral-600 text-neutral-300 hover:text-white"
                    onClick={() => window.open(profileCardData.profile.booking_link, "_blank")}
                  >
                    <Calendar className="w-4 h-4 mr-2" />
                    Book a Meeting
                  </Button>
                )}
                <Button
                  className="w-full bg-[#39FF14] text-black hover:bg-[#32e612]"
                  onClick={() => { handleConnect(profileCardUserId, profileCardData.user?.name); setProfileCardUserId(null); setProfileCardData(null); }}
                  data-testid="profile-card-connect-btn"
                >
                  <UserPlus className="w-4 h-4 mr-2" />
                  Connect
                </Button>
              </div>
            </>
          ) : (
            <div className="text-center py-8 text-neutral-500">
              <DialogHeader className="sr-only"><DialogTitle>Profile Not Found</DialogTitle></DialogHeader>
              Profile not found
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
